import { BellIcon as Bell01, LockUnlockedIcon as LockUnlocked03, StarsIcon as Stars01 } from '@orn/shared-web/icons';
import { cx } from '@orn/shared-web/utils/cx';
import * as React from 'react';

interface ITrialStep {
  icon: React.ComponentType<React.SVGAttributes<SVGSVGElement>>;
  label: string;
  description: string;
}

const TRIAL_STEPS: ITrialStep[] = [
  {
    icon: LockUnlocked03,
    label: 'Today',
    description: 'Your 30 day free trial begins and you are not charged',
  },
  {
    icon: Bell01,
    label: 'In 21 days',
    description: "We'll send you a reminder one week before your trial ends",
  },
  {
    icon: Stars01,
    label: 'In 30 days',
    description:
      "We'll notify you again on the day your trial ends before charging. Cancel anytime during your trial — no questions asked",
  },
];

interface IFreeTrialInfoProps {
  className?: string;
}

/**
 * Informational card explaining the three-step lifecycle of a 30-day free
 * trial (start, reminder, end-of-trial). Purely presentational — copy and
 * timing are hardcoded to the values defined in the Figma design.
 */
const FreeTrialInfo = ({ className }: IFreeTrialInfoProps) => {
  return (
    <div
      className={cx(
        'bg-utility-mist-100 border-utility-mist-500 shadow-xs flex w-[440px] flex-col items-start justify-center gap-5 rounded-xl border px-6 py-5',
        className
      )}
    >
      <p className="text-text-primary text-xl font-semibold">How your free trial works</p>
      <ol className="flex w-full flex-col">
        {TRIAL_STEPS.map((step, idx) => {
          const isLast = idx === TRIAL_STEPS.length - 1;
          const Icon = step.icon;
          return (
            <li key={step.label} className="relative flex w-full items-start gap-3" style={{ height: 90 }}>
              <span
                className="absolute"
                style={{
                  left: 11,
                  top: 32,
                  bottom: 0,
                  width: 2,
                  background: isLast
                    ? 'linear-gradient(to bottom, var(--color-bg-brand-solid), transparent)'
                    : 'var(--color-bg-brand-solid)',
                }}
                aria-hidden="true"
              />
              <div className="bg-brand-solid relative z-10 mt-1 flex size-6 shrink-0 items-center justify-center rounded-full">
                <Icon className="size-3 shrink-0 text-white" aria-hidden="true" />
              </div>
              <div className="flex flex-1 flex-col pt-0.5">
                <p className="text-text-primary text-md font-semibold">{step.label}</p>
                <p className="text-text-tertiary text-sm">{step.description}</p>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default FreeTrialInfo;
